import './SetupCompany.scss';

import { ChangeEvent, FC, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Company } from 'models/Company';
import { EntityName } from 'models/Entities';
import { Col, Form, Row } from 'react-bootstrap';

import { WizardStepInfo } from '../SetupWizard/WizardStepInfo';
import WizardActions from '../WizardActions/WizardActions';


interface CompanyProps extends WizardStepInfo {
  cachedCompany: Company;
  onUpdate: (entity: string, key: string, value: any) => void;
}

const SetupCompany: FC<CompanyProps> = ({ cachedCompany, onUpdate, ...wizardContext }) => {
  const onEntityFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
    onUpdate(EntityName.Company, event.target.name, event.target.value);
  };
  const { user } = useAuth0();
  const [userName, setUserName] = useState('');
  useEffect(() => {
    if (user && user.name) {
      setUserName(user.name);
    }
  }, [user]);

  const [validated, setValidated] = useState(false);
  const onFormValidated = (validationResult: boolean) => {
    setValidated(validationResult);
  };
  const modifiedWizardContext = { ...wizardContext, onFormValidated };

  return (
    <div className="Company">
      <h1 className="wizard-title text-center">Basic Information</h1>
      <Form validated={validated} noValidate>
        <div className="wizard-content">
          <Form.Group as={Row} className="mb-4">
            <Form.Label column sm={2}>
              Your Username
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={userName} readOnly disabled />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="name" className="mb-4">
            <Form.Label column sm={2}>
              Company Name
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                value={cachedCompany.name || ''}
                onChange={onEntityFieldChange}
                aria-label="company name"
                name="name"
                autoComplete="organization"
                placeholder="Company Name"
                className="form-control"
                tabIndex={1}
                required
              />
              <Form.Control.Feedback type="invalid">
                Please enter a company name.
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="ownerName" className="mb-4">
            <Form.Label column sm={2}>
              Owner Name
            </Form.Label>
            <Col sm={10}>
              <Form.Control
                type="text"
                value={cachedCompany.ownerName || ''}
                onChange={onEntityFieldChange}
                aria-label="Owner's Name"
                name="ownerName"
                autoComplete="name"
                placeholder="First Last"
                className="form-control"
                tabIndex={1}
                required
              />
              <Form.Control.Feedback type="invalid">
                Please enter company owner&#39;s name.
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
        </div>
        <WizardActions {...modifiedWizardContext} />
      </Form>
    </div>
  );
};

export default SetupCompany;
